import React from 'react';
import { useTranslation } from 'react-i18next';

const TermsCondition = () =>{
    const { t, i18n } = useTranslation();
    return(
        <div className='container py-5' style={{direction:"ltr"}}>
            <div className='termsCondition' dangerouslySetInnerHTML={{ __html:  t('footer.termscondition').replace(/(&nbsp;|\s)+/g, ' ') }}></div>
        </div> 
    );


}

export default TermsCondition;